function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Adapted from https://www.npmjs.com/package/its-fine to support React 17.
 * The main change is using `nanoid` instead of `useId` which doesn't exist in React 17.
 * Also tweaked a bit of the code to match our style and removed the parts we don't use.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { nanoid } from 'nanoid';
import * as React from 'react';

/**
 * Represents a react-internal Fiber node.
 */

/**
 * Represents a {@link Fiber} node selector for traversal.
 */
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Traverses up or down a {@link Fiber}, return `true` to stop and select a node.
 */
function traverseFiber(/** Input {@link Fiber} to traverse. */
fiber, /** Whether to ascend and walk up the tree. Will walk down if `false`. */
ascending, /** A {@link Fiber} node selector, returns the first match when `true` is passed. */
selector) {
  if (!fiber) {
    return;
  }
  if (selector(fiber) === true) {
    return fiber;
  }
  var child = ascending ? fiber.return : fiber.child;
  while (child) {
    var match = traverseFiber(child, ascending, selector);
    if (match) {
      return match;
    }
    child = ascending ? null : child.sibling;
  }
}

// In development, React will warn about using contexts between renderers.
// Hide the warning because its-fine fixes this issue
// https://github.com/facebook/react/pull/12779
function wrapContext(context) {
  try {
    return Object.defineProperties(context, {
      _currentRenderer: {
        get() {
          return null;
        },
        set() {
          /* no-op */
        }
      },
      _currentRenderer2: {
        get() {
          return null;
        },
        set() {
          /* no-op */
        }
      }
    });
  } catch (_) {
    return context;
  }
}

// eslint-disable-next-line react-refresh/only-export-components
var FiberContext = /* @__PURE__ */wrapContext(
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
/* @__PURE__ */
React.createContext(null));
FiberContext.displayName = 'FiberContext';

/**
 * A react-internal {@link Fiber} provider. This component binds React children to the React Fiber tree. Call its-fine hooks within this.
 */
export class FiberProvider extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "_reactInternals", void 0);
  }
  render() {
    var children = this.props.children;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line no-underscore-dangle
      _jsx(FiberContext.Provider, {
        value: this._reactInternals,
        children: children
      })
    );
  }
}

/**
 * Returns the current react-internal {@link Fiber}. This is an implementation detail of [react-reconciler](https://github.com/facebook/react/tree/main/packages/react-reconciler).
 */
export function useFiber() {
  var root = React.useContext(FiberContext);
  if (root === null) {
    throw new Error('useFiber must be called within a <FiberProvider />!');
  }
  var _React$useState = React.useState(() => nanoid()),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    id = _React$useState2[0];
  var actualFiber = React.useMemo(() => {
    // eslint-disable-next-line no-restricted-syntax
    for (var maybeFiber of [root, root === null || root === void 0 ? void 0 : root.alternate].filter(r => r != null)) {
      var fiber = traverseFiber(maybeFiber, false, node => {
        var state = node.memoizedState;
        while (state != null) {
          if (state.memoizedState === id) {
            return true;
          }
          state = state.next;
        }
      });
      if (fiber) {
        return fiber;
      }
    }
  }, [root, id]);
  return actualFiber;
}
//# sourceMappingURL=useFiber.js.map